// extracted by mini-css-extract-plugin
module.exports = {"container":"SimpleRow-module__container__1aiuP","titles":"SimpleRow-module__titles__3QP1L"};